'use client';

import React, { FC } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import styles from './Modal.module.scss';

type ModalTypeProps = {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  disableBackdropClick?: boolean;
  backdropClassName?: string;
  viewType?: 'full' | 'top' | 'bottom' | 'center';
};

const Modal: FC<ModalTypeProps> = ({
  isOpen,
  onClose,
  disableBackdropClick = false,
  backdropClassName,
  viewType = 'center',
  children,
}) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={clsx(styles.backdrop, backdropClassName)} />

        <div className={clsx(styles.position_wrapper, styles[viewType])}>
          <Dialog.Content
            className={styles.modal}
            onPointerDownOutside={(e) => {
              if (disableBackdropClick) {
                e.preventDefault();
              }
            }}
          >
            <Dialog.Title style={{ display: 'none' }}>Modal</Dialog.Title>

            {children}
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { Modal };
